<template>
  <div class>
    <section class="d-flex flex-column h-full">
      <!-- <div class="fixed-header w-full"> -->
      <TopAppBar
        :leftBtnMode="leftBtnMode"
        :rightBtnMode="rightBtnMode"
        :title="title"
        :leftBtnMethod="leftBtnMethod"
        :rightBtnMethod="rightBtnMethod"
        staticMode="true"
      ></TopAppBar>
    </section>

    <NoData v-if="isNoData"></NoData>

    <div class="pdt-16 pdl-8 pdr-8 pdb-20">
      <div
        v-for="(mission, index) in listData"
        :key="index"
        class="lesson-item"
        @click="moveToLessonList(mission.learnerId,mission.assignmentId)"
      >
        <div
          class="d-flex flex-column justify-content-between header-card mdc-card mdc-elevation--z3 mgb-16 pdt-12 pdb-16 mgl-8 mgr-8 bg-white pda-default"
        >
          <div class="font-b t-subtitle2 t-color-title l-spacing48">
            {{ mission.degreeName | charLength }}
          </div>
          <div class="d-flex pdt-16">
            <div class="pdr-8">
              <img src="images/portfolio/misson.svg" class="profile min-w-40" />
              <!-- <div class="progress mgt-6">
                <div class="progress-body">
                  <div class="progress-sub" :style="`width:${lesson.rate}%;`"></div>
                </div>
                <div class="t-helper progress-text">{{parseInt(lesson.rate)}}%</div>
              </div> -->
            </div>
            <div class="pdl-8 pdr-8 flex-grow-1">
              <div class="t-body1">
                {{ mission.missionName | charLength }}
                <div class="t-body3 t-color-gray2">
                  <!-- {{mission.status}} -->
                  <div v-if="mission.status === 'WAITING'">
                    {{ $t("205") }}
                    <!-- 제출 불가 -->
                  </div>
                  <div v-else-if="mission.status === 'SUBMISSIBLE'">
                    <!-- {{$t('201')}} -->
                    <!-- 미제출 -->
                  </div>
                  <div v-else-if="mission.status === 'SUBMITTED'">
                    {{ $t("201") }}
                    <!-- 제출됨 -->
                  </div>
                  <div v-else-if="mission.status === 'UNDER_EVALUATION'">
                    {{ $t("203") }}
                    <!-- 평가 진행 중 -->
                  </div>
                  <div v-else-if="mission.status === 'EVALUATED'">
                    {{ $t("206") }}
                    <!-- 평가 완료 -->
                  </div>
                  <div v-else-if="mission.status === 'TERMINATION'">
                    {{ $t("TODO-종료") }}
                    <!-- 종료 -->
                  </div>
                  <div
                    class="mission-reject-box d-inline-block mgt-4"
                    v-else-if="mission.status === 'REJECT'"
                  >
                    <img
                      src="@/assets/mission_error_icon.svg"
                      class="w-13 h-12 d-inline-block"
                    />
                    <span class="mgl-4 mgr-4">
                      {{ $t("204") }}
                      <!-- 과제물 반려 -->
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="d-flex flex-row-reverse mgr-16 mgl-16">
            <span>{{ mission.feedbackCount }}</span>
            <div class="position-relative">
              <div class="w-16 h-16 mgr-4 mgl-4">
                <img src="@/assets/mission_feedback_icon.svg" class="" />
              </div>
              <div class="dot" v-if="mission.feedbackUnread"></div>
            </div>
          </div> -->
        </div>
      </div>
      <infinite-loading
        @infinite="fetchData"
        :identifier="infiniteId"
        spinner="spiral"
      >
        <div slot="no-more" class="mgt-16"></div>
        <div slot="no-results" class="mgt-16"></div>
      </infinite-loading>
    </div>
  </div>
</template>

<script>
// Components/Mixin/Extend/API define
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import { MDCRipple } from "@material/ripple";
import { fileMixin } from "@/mixins/file.js";
import portfolioApi from "@/api/portfolioApi.js";
import NoData from "../common/NoDataBookMarkedMission.vue";
import InfiniteLoading from "vue-infinite-loading";

export default {
  components: {
    NoData,
    InfiniteLoading,
    TopAppBar,
  },
  filters: {
    charLength(value) {
      if (value.length > 40) {
        return value.substring(0, 42) + "..";
      } else {
        return value;
      }
    },
  },
  data() {
    return {
      status: "",
      leftBtnMethod: () => {
        this.$router.go(-1);
      },
      isNoData: false,
      campaignData: null,
      listData: [],
      currentPage: 1,
      totalPages: 1,
      infiniteId: +new Date(),
    };
  },
  mixins: [topAppBarMixin, fileMixin],
  computed: {},

  watch: {
    $route(to, from) {
      this.initData();
    },
  },
  mounted() {
    // 기본 파라미터 설정(set default parameter)
    this.setTopAppBarBackPortfolio(this.$t("1846"));
  },

  methods: {
    initData() {
      this.listData = [];
      this.currentPage = 1;
      this.totalPages = 1;
      this.infiniteId += 1;
    },
    // 목록 데이터 로딩(get list data)
    fetchData($state) {
      let responseData = null;
      let responseDatas = null;
      if (this.totalPages >= this.currentPage) {
        portfolioApi
          .bookedMarkedMissionList()
          .then((response) => {
            responseData = response.data.data;
            console.log("responseData=>", responseData);
            this.listData = this.listData.concat(responseData.content);
            this.currentPage++;
            this.totalPages = responseData.totalPages;

            if (responseData.content.length) {
              $state.loaded();
            } else {
              $state.complete();
            }

            console.log("nodata", this.listData.length);
            if (this.listData.length > 0) {
              this.isNoData = false;
            } else {
              this.isNoData = true;
            }
          })
          .catch((err) => {
            //$state.error();
          });
      } else {
        $state.complete();
      }
    },
    moveToLessonList(learnerId,assignmentId){
      localStorage.setItem('bookMarkMission','setGoBackBookMarkMission')
      this.$router.push('learn/'+learnerId+'/mission/'+assignmentId+'?status=LEARNING')
    },
    // 학습진행률 노출 상태 설정(set/toggle learning status graph)
    initProgressStatus(id) {
      _.map(this.listData, (o) => {
        o.id === id && o.progressViewStatus === false
          ? (o.progressViewStatus = true)
          : (o.progressViewStatus = false);
      });
    },
  },
};
</script>

<style scoped>
.mdc-elevation--z3 {
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  background-color: #ffffff;
}
.tabs .tab {
  width: 50%;
}
.badge-chip {
  bottom: 0;
  right: 0;
  border-radius: 12px;
}
.two-column {
  flex-wrap: wrap;
}
.two-column > div {
  flex: 0 0 50%;
}
.count {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
}
:root {
  --customColor1: #ff847b;
  --customColor2: #b295e6;
  --customColor3: #ffad6e;
  --customColor4: #70cfc8;
}

.count-back {
  width: 48px;
  height: 48px;
  top: 0;
  left: 0;
  border-radius: 50%;
  opacity: 0.15;
}
.z-99 {
  z-index: 99;
}
.bg-custom1 {
  background: var(--customColor1);
}
.t-color-custom1 {
  color: var(--customColor1);
}
.bg-custom2 {
  background: var(--customColor2);
}
.t-color-custom2 {
  color: var(--customColor2);
}
.bg-custom3 {
  background: var(--customColor3);
}
.t-color-custom3 {
  color: var(--customColor3);
}
.bg-custom4 {
  background: var(--customColor4);
}
.t-color-custom4 {
  color: var(--customColor4);
}

span.swiperImageIndicator {
  right: 8px;
  bottom: 8px;
  background: rgba(0, 0, 0, 0.18);
  border-radius: 30px;
}
.swiperSlideWrapper {
  width: 70%;
}
.swiperPercentWrapper {
  line-height: 0.5;
}
.swiperImageHolder img {
  max-height: 130px;
  object-fit: cover;
}

.cardInner {
  border-bottom: 1px solid rgba(172, 180, 190, 0.7);
}
.cardInner:last-child {
  border-bottom: none;
}
.swiper-slide {
  width: 232px;
}
.line-through:after {
  position: absolute;
  content: "";
  width: 100%;
  height: 1px;
  background: red;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
@media (min-width: 768px) {
  .bubble-image {
    width: 300px;
  }

  .swiperSlideWrapper {
    width: 350px;
  }
  .swiper-slide {
    width: auto;
  }
  .swiperImageHolder img {
    min-height: 235px;
    object-fit: cover;
  }
}
</style>